var map = {
	"./cnr/translation.toml": [
		19548,
		548
	],
	"./de/translation.toml": [
		30732,
		732
	],
	"./en/translation.toml": [
		48068,
		68
	],
	"./es-mx/translation.toml": [
		5727,
		727
	],
	"./fr/translation.toml": [
		28695,
		695
	],
	"./hi/translation.toml": [
		37156,
		156
	],
	"./it/translation.toml": [
		59226,
		226
	],
	"./nl/translation.toml": [
		38269,
		650
	],
	"./ph/translation.toml": [
		35027,
		27
	],
	"./pl/translation.toml": [
		71103,
		103
	],
	"./pt-br/translation.toml": [
		19482,
		482
	],
	"./pt-pt/translation.toml": [
		82666,
		666
	],
	"./pt/translation.toml": [
		49271,
		271
	],
	"./template/translation.toml": [
		91473
	],
	"./uwu/translation.toml": [
		91266,
		266
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 97363;
module.exports = webpackAsyncContext;